
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
    attributeName: 'tableMonitor',
    getURL: 'live/logs',
    canOpen: false,
    canEdit: false,
    canCreate: false,
    canRemove: false,
    emptyMessage: "No logs to display",
    rowHighlight: [
        {
        key: "type",
        value: "Cloud",
        class: "highlight-row-clear"
      },
      {
        key: "type",
        value: "Ingest",
        class: "highlight-row-dark"
        },    
    ],
    collapsable: {
        key: "type",
        relation: "id",
        values: {
            master: "Cloud",
            slave: "Ingest"
        }
    },
  emptyMessage: "You have no logs.",
  fields: [
    {
      attributeName: 'type',
      label: 'Log Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Cloud/ingest',
      canFilter: true
    },
    {
      attributeName: 'startDate',
      label: 'Start Date',
      type: FormInputTypes.CELL_DATE,
      mode:"date",
      width: '12rem',
      helpText: 'Cloud/ingest',
      canFilter: true
    },    
    {
      attributeName: 'endDate',
      label: 'End Date',
      type: FormInputTypes.CELL_DATE,
      mode:"date",
      width: '12rem',
      helpText: 'Cloud/ingest',
      canFilter: true
    },
    {
      attributeName: 'cameraTypes',
      label: 'Camera Types',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Cloud/ingest',
      default: '-',
      canFilter: true
    },
    {
      attributeName: 'nOfCameras',
      label: 'Number of cameras',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Cloud/ingest',
      default: '-'
    },
    {
        attributeName: 'session',
        label: 'Session',
        type: FormInputTypes.TEXT_INPUT.TEXT,
        width: '12rem',
        helpText: 'Cloud/ingest',
        default: '-'
      },
      {
        attributeName: 'duration',
        label: 'Duration',
        type: FormInputTypes.TEXT_INPUT.TEXT,
        width: '12rem',
        helpText: 'Cloud/ingest',
        default: '-'
      },
      {
        attributeName: 'startTime',
        label: 'Start Time',
        type: FormInputTypes.CELL_DATE,
        mode:"time",
        width: '12rem',
        helpText: 'Cloud/ingest'
      },
      {
        attributeName: 'endTime',
        label: 'End Time',
        type: FormInputTypes.CELL_DATE,
        mode:"time",
        width: '12rem',
        helpText: 'Cloud/ingest'
      },
  ],
};
